<template>
    <div id="inner" style="width: 100%;height: 100%;display: flex;flex-direction: column;">

        <div id="listBar" style="background: white;width: 100%;display: flex;flex: 1;">
            <div style="display: flex;flex-direction: column;flex-shrink: 0;height: 100%;overflow: auto;" :style="{
                height: listBarHeight + 'px'
            }">
                <div @click="scrollToCategory(index)" v-for="item, index in typeList" :key="index"
                    style="padding:10px 5px;width: 80px; overflow: hidden;text-overflow: ellipsis;" :style="{
                        background: currentIndex == index ? 'white' : '#EBEDF0',
                        color: currentIndex == index ? 'black' : 'grey',
                    }">{{ item }}</div>
            </div>
            <div @scroll="handleScroll" ref="scroller"
                style="display: flex;flex-direction: column;flex: 1;margin-left: 10px;height: 100%;overflow: auto; scrollbar-width: none;-ms-overflow-style: none;"
                :style="{ height: listBarHeight + 'px' }">
                <div :ref="`section-${mapIndex}`" v-for="(value, key, mapIndex) in companyMap" :key="key"
                    style="display: flex;flex-direction: column;">
                    <div style="width: 100%;text-align: left;font-weight: 700;">{{ key }}</div>
                    <div v-for="item, index in value" :key="index"
                        style="padding: 10px;width: calc(100% - 20px);display: flex;">
                        <img style="width: 80px;height: 80px;"
                            :src="resourceBase + '/assets/itemImg/' + item.itemHeadImg.split(';')[0]" alt="">
                        <div
                            style="display: flex;flex-direction: column;justify-content: space-between;height: 100%;margin-left: 10px;flex: 1;">
                            <div style="
                                font-size: large;
                                font-weight: 700;
                                text-align: left;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                width: 100%;
                                ">{{ item.itemName }}</div>
                            <div style="flex: 1;display: flex;justify-content: space-between;align-items: center;">

                                <div style="color: grey;font-size: small;">已售{{ item.itemSales }}</div>
                            </div>
                            <div
                                style="width: 100%;display: flex;justify-content: space-between;align-items: flex-end;">
                                <div style="display: flex;align-items: center;">
                                    <div style="color: #EA9518;font-weight: 700;font-size: large;">¥{{ item.itemPrice
                                    }}元
                                    </div>
                                </div>


                            </div>
                            <div style="width: 100%;display: flex;justify-content: space-between;">
                                <div style="display: flex;align-items: center;">
                                    <div
                                        style="background: #EA9518;color: white;font-weight: 700;padding:0px 2px;border-radius: 2px;font-size: x-small;">
                                        {{ item.discount }}折</div>
                                    <div
                                        style="margin-left: 5px;color: grey;text-decoration: line-through;font-size: small;">
                                        {{
                                            item.itemLastPrice
                                        }}元</div>
                                </div>
                                <div @click="gotoItemDetail(item.id)" v-if="companyType >= 9"
                                    style="background: #EA9518;color: white;font-weight: 700;padding: 2px 10px;border-radius: 10px;">
                                    抢购</div>

                                <div style="display: flex;align-items: center;" v-if="companyType < 9">
                                    <div v-if="shoppingCartInfo.itemInfoList.get(item.id) != null && shoppingCartInfo.itemInfoList.get(item.id) > 0"
                                        @click.prevent="delInShoppingCart(item.id, item.itemPrice)"
                                        style="background: #EA9518;color: white;font-weight: 700;width: 20px;height: 20px;display: flex;justify-content: center;align-items: center;border-radius: 50%;">
                                        -</div>
                                    <div style="margin: 0 5px;"
                                        v-if="shoppingCartInfo.itemInfoList.get(item.id) != null && shoppingCartInfo.itemInfoList.get(item.id) > 0">
                                        {{ shoppingCartInfo.itemInfoList.get(item.id) }}</div>
                                    <div @click.prevent="addInShoppingCart(item.id, item.itemPrice)"
                                        style="background: #EA9518;color: white;font-weight: 700;width: 20px;height: 20px;display: flex;justify-content: center;align-items: center;border-radius: 50%;">
                                        +</div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
                <div style="padding: 10px;width: calc(100% - 20px);display: flex;flex-shrink: 0;height: 60px;display: flex;justify-content: center;align-items: center;">
                    <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
                    <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>

<script>
import request from "../axios/request";
export default {
    name: "ServerItemListView",
    props: {
        companyId: {
            type: Number,
            required: true,
        },
        companyType: {
            type: Number,
            required: true,
        },
        shoppingCartInfo: {
            type: Object,
            default: () => ({
                itemInfoList: new Map(),
                total: 0
            })
        }
    },
    data() {
        return {
            serviceItemList: [],
            resourceIp: null,
            resourceBase: /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) ? 'https://yuanhuihuanhuan.com' : window.location.origin,
            companyMap: null,
            typeList: [],
            listBarHeight: null,
            currentIndex: 0,
        }
    },
    mounted() {


        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {

                    this.listBarHeight = entry.contentRect.height;
                }
            });
        });
        resizeObserver.observe(document.getElementById("listBar"));
        this.resourceIp = this.extractIPFromURL(window.location.origin);

        this.getCompanyItemMap()
    },
    methods: {
        delInShoppingCart(itemId, price) {
            const itemInfo = {
                id: itemId,
                price: price
            }
            this.$emit('delItemInShoppingCart', itemInfo);

        },
        addInShoppingCart(itemId, price) {
            let selectedItem = null
            Object.values(this.companyMap || {}).some(list => {
                selectedItem = list.find(item => item.id === itemId)
                return Boolean(selectedItem)
            })
            const itemInfo = {
                id: itemId,
                price: price,
                item: selectedItem
            }
            this.$emit('addItemInShoppingCart', itemInfo);

        },
        gotoItemDetail(itemId) {
            this.$router.push({
                path: '/companyItem/' + itemId
            })
        },
        extractIPFromURL(url) {
            try {
                // 方法1：优先使用浏览器原生URL对象解析（兼容现代浏览器）
                const parsedUrl = new URL(url);
                const hostname = parsedUrl.hostname;

                // 如果是IPv6地址（如[2001:db8::1]），去除方括号
                if (hostname.startsWith('[') && hostname.endsWith(']')) {
                    return hostname.slice(1, -1);
                }

                // 如果是IPv4地址或域名，直接返回
                return hostname;
            } catch (e) {
                // 方法2：URL对象解析失败时，使用正则表达式作为兜底方案
                const ipv4Regex = /(?:\d{1,3}\.){3}\d{1,3}/; // 匹配IPv4
                const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i; // 匹配域名[1,4](@ref)

                // 尝试匹配IPv4
                const ipMatch = url.match(ipv4Regex);
                if (ipMatch) return ipMatch[0];

                // 尝试匹配域名
                const domainMatch = url.match(domainRegex);
                if (domainMatch && domainMatch[1]) {
                    return domainMatch[1].replace(/^www\./, ''); // 可选：去除www前缀
                }

                return null; // 均未匹配时返回null
            }
        },
        calculateOffsets() {
            let index = 0
            let listBarTop = document.getElementById("listBar").offsetTop
            for (const category in this.companyMap) {
                const el = this.$refs[`section-${index}`]?.[0]
                this.companyMap[category].endPosition = el.offsetTop + el.clientHeight - listBarTop;
                index++
            }

        },
        scrollToCategory(index) {
            const el = this.$refs[`section-${index}`]?.[0];
            if (el) {
                const targetPosition = index > 0 ? this.companyMap[this.typeList[index - 1]].endPosition : 0;
                const scroller = this.$refs.scroller;

                // 取消正在进行的滚动
                if (this.scrollTimeout) {
                    cancelAnimationFrame(this.scrollTimeout);
                }

                // 设置标志，防止 handleScroll 干扰
                this.isProgrammaticScroll = true;

                scroller.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });

                // 滚动完成后恢复
                setTimeout(() => {
                    this.isProgrammaticScroll = false;
                }, 500);

                this.currentIndex = index;
            }
        },
        handleScroll() {
            // 节流：每 16ms 执行一次（约 60fps）
            const now = Date.now();
            if (now - this.lastScrollTime < 16 || this.isProgrammaticScroll) {
                return;
            }
            this.lastScrollTime = now;

            // 防抖：清除之前的定时器
            if (this.scrollTimeoutId) {
                clearTimeout(this.scrollTimeoutId);
            }

            this.scrollTimeoutId = setTimeout(() => {
                this.calculateCurrentIndex();
            }, 50); // 50ms 防抖
        },
        calculateCurrentIndex() {
            const scrollTop = this.$refs.scroller.scrollTop;

            // 使用二分查找优化
            const index = this.binarySearchCurrentIndex(scrollTop);

            if (index !== -1 && index !== this.currentIndex) {
                this.currentIndex = index;
            }
        },
        binarySearchCurrentIndex(scrollTop) {
            const positions = Object.values(this.companyMap)
                .map(item => item.endPosition)
                .sort((a, b) => a - b);

            let left = 0;
            let right = positions.length - 1;
            let result = 0;

            while (left <= right) {
                const mid = Math.floor((left + right) / 2);

                if (scrollTop < positions[mid]) {
                    result = mid;
                    right = mid - 1;
                } else {
                    left = mid + 1;
                }
            }

            return result;
        },
        async getCompanyItemMap() {
            let res = await request({
                url: "/item/api/getCompanyItemMap?companyId=" + this.companyId,
                method: "get",
            })
            if (res.data.status == 200) {

                this.companyMap = res.data.data;
                if (this.companyMap == null) {
                    return;
                }
                this.typeList = Object.keys(this.companyMap)
                this.$nextTick(() => {
                    this.calculateOffsets();
                });
            }
        }
    }
}
</script>
